import { motion, useReducedMotion } from 'framer-motion';
import { Left } from '@urbaninfrastructure/react-icons';
import { Flex, AnchorButton, Hide } from '..';
import { FormattedMessage } from 'react-intl';
import { SvgIconInternalProps } from '@urbaninfrastructure/react-icons/lib/Svg';

export function BackButton({
  variant,
  onClick,
  disabled,
  iconSize
}: {
  variant: 'visible' | 'hidden';
  onClick: () => void;
  disabled?: boolean;
  iconSize: SvgIconInternalProps['size'];
}) {
  const shouldReduceMotion = useReducedMotion();
  return (
    <motion.div
      animate={variant}
      variants={{
        visible: { opacity: 1, y: 0 },
        hidden: { opacity: 0, y: shouldReduceMotion ? 0 : -100 }
      }}
      initial="hidden"
      style={{ position: 'absolute', left: 0, top: 0 }}
    >
      <AnchorButton
        onClick={onClick}
        textDecoration="none"
        disabled={disabled}
        color="link"
        p={0}
        m={0}
        mute={disabled}
        typoStyle="xxs"
        css={`
          line-height: 1;
          background: none;
          border: none;
        `}
      >
        <Flex as="span" justifyContent="center" alignItems="center">
          <Left size={iconSize} color="primaryIcon" />
          <Hide xs sm srOnly>
            <FormattedMessage id="WizardLayout.back" defaultMessage="Back" />
          </Hide>
        </Flex>
      </AnchorButton>
    </motion.div>
  );
}
